import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/api/api.js";
import { Row } from "react-bootstrap";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import FiscalDocumentCard from "@/pages/shared/sections/FiscalDocumentCard.jsx";
import FolioExpiryNotice from "@/pages/shared/sections/FolioExpiryNotice.jsx";
import QuotaCard from "@/pages/shared/sections/QuotaCard.jsx";

/**
 * El Inicio del usuario: sus folios, lo que le entrega su contador y lo que su
 * paquete le incluye.
 *
 * Las banderas se preguntan una vez aquí y no una por tarjeta, y quien manda es
 * el servidor: esconder una tarjeta no restringe nada, sólo evita ofrecer algo
 * que el API va a negar.
 */
const Bills = ({ companyId }) => {
  const { t } = useTranslation();
  const [folios, setFolios] = useState({ count: 0, expiration: null });
  const [capabilities, setCapabilities] = useState({});
  const [quotas, setQuotas] = useState(null);

  useEffect(() => {
    api
      .get("/billings/available-count")
      .then(({ data }) => setFolios(data))
      // Si falla, la tarjeta se queda en cero y sin aviso.
      .catch(() => setFolios({ count: 0, expiration: null }));

    api
      .get("/package-capabilities")
      .then(({ data }) => setCapabilities(data))
      .catch(() => setCapabilities({}));

    api
      .get("/package-quotas")
      .then(({ data }) => setQuotas(data))
      .catch(() => setQuotas(null));
  }, []);

  return (
    <>
      <FolioExpiryNotice expiration={folios.expiration} />

      <Row>
        <div className="col-xxl-4 col-md-6">
          <div className="card info-card sales-card">
            <div className="card-body">
              <h5 className="card-title">
                {capitalizeFirstLetter(t("bills available"))}
              </h5>
              <div className="d-flex align-items-center">
                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i className="bi bi-cart"></i>
                </div>
                <div className="ps-3">
                  <h6>{folios.count}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        {capabilities.fiscalCertificate && (
          <FiscalDocumentCard companyId={companyId} type="fiscalCertificate" />
        )}

        {capabilities.complianceOpinion && (
          <FiscalDocumentCard companyId={companyId} type="complianceOpinion" />
        )}

        <QuotaCard type="advisories" quota={quotas?.advisories} />
        <QuotaCard type="consultations" quota={quotas?.consultations} />
      </Row>
    </>
  );
};

export default Bills;
